export default __webpack_public_path__ + "static/media/VontoCards_FTL.d2cb78a7.svg";